import { Maybe } from 'graphql/jsutils/Maybe'
import React from 'react'
import { FormattedMessage } from 'react-intl'

import s from './styles.module.scss'

import { Icon, Tooltip } from '../../atoms'
import { AddressFragment, CurrencyAreaOutputDto } from '../../../lib/graphql'
import { getCountryFlagIconFromCountryIsoCode } from '../../../utils/get-country-flag-icon-from-country-iso-code.helper'
import { divideByFactor } from '../../../utils/prices'

interface AddressFormFieldLabelWithCurrencyAreaProps {
  label: string
  address: Maybe<Pick<AddressFragment, 'country' | 'countryIsoCode'>>
  currencyArea: CurrencyAreaOutputDto
}
const AddressFormFieldLabelWithCurrencyAreaTooltip = ({
  address,
  currencyArea,
  label,
}: AddressFormFieldLabelWithCurrencyAreaProps) => {
  return (
    <div className={s.container}>
      <p>{label}</p>

      {address ? (
        <Tooltip
          position='right'
          className={s.tooltip}
          contentClassName={s.tooltipContent}
          content={
            <>
              <p>
                <FormattedMessage
                  id='ui.currencyAreaTooltip.country'
                  defaultMessage='Pays : {country}'
                  values={{ country: address.country ?? '' }}
                />
                &nbsp;
                <span>
                  {getCountryFlagIconFromCountryIsoCode({
                    countryIsoCode: address.countryIsoCode,
                  })}
                </span>
              </p>

              <p>
                <FormattedMessage
                  id='ui.currencyAreaTooltip.currency'
                  defaultMessage='Devise : {currency}'
                  values={{ currency: currencyArea.currency }}
                />
              </p>

              <p>
                <FormattedMessage
                  id='ui.currencyAreaTooltip.vatRates'
                  defaultMessage='TVA {vatRates}'
                  values={{
                    vatRates: currencyArea.vatRates
                      .map((rate) => `${divideByFactor(rate)}%`)
                      .join(', '),
                  }}
                />
              </p>
            </>
          }
        >
          <Icon name='info-filled' size={18} color='var(--NABLUE, #1067EB)' />
        </Tooltip>
      ) : null}
    </div>
  )
}

export default AddressFormFieldLabelWithCurrencyAreaTooltip
